import React from 'react';
import PriceWidget from './PriceWidget';
const Price = ({pricefrom, priceto, currency, onChoose}) => {
  return (
    <PriceWidget
      pricefrom={pricefrom}
      priceto={priceto}
      currency={currency}
      onChoose={onChoose}
    />
  );
};
export default Price;
